import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, InstagramIcon, CheckIcon } from 'lucide-react';
export function ContactPage({
  onBack
}: {
  onBack: () => void;
}) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const handleSubmit = () => {
    if (!name || !email || !message) return;
    setIsProcessing(true);
    setTimeout(() => {
      setSubmitted(true);
      setIsProcessing(false);
    }, 1400);
  };
  return <div className="min-h-screen w-full bg-[#050505] pt-24 pb-20 px-4 sm:px-6" data-id="element-642">
      <div className="max-w-6xl mx-auto" data-id="element-643">
        {/* Back */}
        <motion.button initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.4
      }} onClick={onBack} className="flex items-center gap-2 font-montserrat text-[12px] tracking-widest text-white/40 hover:text-[#C9A84C] transition-colors duration-300 mb-10" data-id="element-644">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" data-id="element-645">
            <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-646" />
          </svg>
          BACK TO HOME
        </motion.button>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-647">
          <span className="font-inter text-[13px] tracking-[0.4em] text-[#C9A84C]/60 uppercase" data-id="element-648">
            Get In Touch
          </span>
          <h1 className="font-montserrat font-black text-4xl sm:text-5xl tracking-widest text-white mt-2" data-id="element-649">
            CONTACT US
          </h1>
          <div className="w-14 h-px bg-[#C9A84C]/50 mx-auto mt-4 mb-10" data-id="element-650" />

          {/* Exterior Shot */}
          <div className="max-w-4xl mx-auto rounded-3xl overflow-hidden h-[300px] border border-[#2A2622] relative group" data-id="element-651">
            <img src="https://cdn.magicpatterns.com/uploads/hYjZfXgLo6SM2QHotNYa4r/WhatsApp-Image-2026-06-16-at-10.13.26-AM-2.jpg" alt="MK Lounge Exterior" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-652" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent opacity-60" data-id="element-653" />
            <div className="absolute bottom-6 left-8 text-left" data-id="element-654">
              <p className="font-montserrat font-black text-xl tracking-widest text-white" data-id="element-655">
                FIND US ON U ST
              </p>
              <p className="font-inter text-sm text-white/70" data-id="element-656">
                Look for the neon "Mk on U" sign
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8" data-id="element-657">
          {/* Info column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="lg:col-span-2 flex flex-col gap-5" data-id="element-658">
            {/* Info cards */}
            <div className="rounded-3xl p-6" style={{
            background: '#0d0b09',
            border: '1px solid #2A2622'
          }} data-id="element-659">
              <div className="flex items-start gap-4" data-id="element-660">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                background: 'rgba(201,168,76,0.12)',
                border: '1px solid rgba(201,168,76,0.2)'
              }} data-id="element-661">
                  <MapPinIcon size={18} className="text-[#C9A84C]" data-id="element-662" />
                </div>
                <div data-id="element-663">
                  <p className="font-montserrat font-black text-[13px] tracking-widest text-white mb-1" data-id="element-664">
                    LOCATION
                  </p>
                  <p className="font-inter text-[15px] text-white/55 leading-relaxed" data-id="element-665">
                    913 U St NW
                    <br data-id="element-666" />
                    Washington, DC 20001
                  </p>
                </div>
              </div>
            </div>

            <div className="rounded-3xl p-6" style={{
            background: '#0d0b09',
            border: '1px solid #2A2622'
          }} data-id="element-667">
              <div className="flex items-start gap-4" data-id="element-668">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                background: 'rgba(201,168,76,0.12)',
                border: '1px solid rgba(201,168,76,0.2)'
              }} data-id="element-669">
                  <ClockIcon size={18} className="text-[#C9A84C]" data-id="element-670" />
                </div>
                <div data-id="element-671">
                  <p className="font-montserrat font-black text-[13px] tracking-widest text-white mb-2" data-id="element-672">
                    HOURS
                  </p>
                  <div className="flex flex-col gap-1.5" data-id="element-673">
                    {[{
                    day: 'Mon – Thu',
                    hours: '5PM – 2AM'
                  }, {
                    day: 'Fri & Sat',
                    hours: '2PM – 3AM'
                  }, {
                    day: 'Sunday',
                    hours: '2PM – 2AM'
                  }].map(item => <div key={item.day} className="flex justify-between" data-id="element-674">
                        <span className="font-inter text-[14px] text-white/45" data-id="element-675">
                          {item.day}
                        </span>
                        <span className="font-inter text-[14px] text-[#C9A84C]/80" data-id="element-676">
                          {item.hours}
                        </span>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>

            <div className="rounded-3xl p-6" style={{
            background: '#0d0b09',
            border: '1px solid #2A2622'
          }} data-id="element-677">
              <div className="flex items-start gap-4" data-id="element-678">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                background: 'rgba(201,168,76,0.12)',
                border: '1px solid rgba(201,168,76,0.2)'
              }} data-id="element-679">
                  <PhoneIcon size={18} className="text-[#C9A84C]" data-id="element-680" />
                </div>
                <div data-id="element-681">
                  <p className="font-montserrat font-black text-[13px] tracking-widest text-white mb-1" data-id="element-682">
                    PHONE
                  </p>
                  <a href="tel:+12025181161" className="font-inter text-[15px] text-white/55 hover:text-[#C9A84C] transition-colors" data-id="element-683">
                    (202) 518-1161
                  </a>
                  <p className="font-montserrat text-[10px] tracking-widest text-white/30 mt-2 mb-1" data-id="element-684">
                    RESERVATIONS / TEXT
                  </p>
                  <a href="sms:2029095158" className="font-inter text-[15px] text-white/55 hover:text-[#C9A84C] transition-colors" data-id="element-685">
                    (202) 909-5158
                  </a>
                  <span className="font-inter text-[13px] text-white/30 mx-1" data-id="element-686">
                    or
                  </span>
                  <a href="sms:2027540850" className="font-inter text-[15px] text-white/55 hover:text-[#C9A84C] transition-colors" data-id="element-687">
                    (202) 754-0850
                  </a>
                </div>
              </div>
            </div>

            <div className="rounded-3xl p-6" style={{
            background: '#0d0b09',
            border: '1px solid #2A2622'
          }} data-id="element-688">
              <div className="flex items-start gap-4" data-id="element-689">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                background: 'rgba(201,168,76,0.12)',
                border: '1px solid rgba(201,168,76,0.2)'
              }} data-id="element-690">
                  <MailIcon size={18} className="text-[#C9A84C]" data-id="element-691" />
                </div>
                <div data-id="element-692">
                  <p className="font-montserrat font-black text-[13px] tracking-widest text-white mb-1" data-id="element-693">
                    EMAIL
                  </p>
                  <a href="mailto:mkloung@gmail.com" className="font-inter text-[15px] text-white/55 hover:text-[#C9A84C] transition-colors" data-id="element-694">
                    mkloung@gmail.com
                  </a>
                </div>
              </div>
            </div>

            {/* Social */}
            <div className="rounded-3xl p-6" style={{
            background: '#0d0b09',
            border: '1px solid #2A2622'
          }} data-id="element-695">
              <p className="font-montserrat font-black text-[13px] tracking-widest text-white mb-4" data-id="element-696">
                FOLLOW US
              </p>
              <div className="flex gap-3" data-id="element-697">
                <a href="https://instagram.com/mk_on_u" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 px-4 py-2.5 rounded-xl font-inter text-[14px] text-white/60 hover:text-[#C9A84C] transition-all duration-300" style={{
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid #2A2622'
              }} data-id="element-698">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-699">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-700" />
                    <circle cx="12" cy="12" r="4" data-id="element-701" />
                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" data-id="element-702" />
                  </svg>
                  @mk_on_u
                </a>
              </div>
            </div>
          </motion.div>

          {/* Contact form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-3" data-id="element-703">
            <div className="rounded-3xl p-7 sm:p-9 h-full" style={{
            background: '#0d0b09',
            border: '1px solid #2A2622',
            boxShadow: '0 8px 40px rgba(0,0,0,0.5)'
          }} data-id="element-704">
              {!submitted ? <>
                  <h2 className="font-montserrat font-black text-xl tracking-widest text-white mb-7" data-id="element-705">
                    SEND A MESSAGE
                  </h2>
                  <div className="flex flex-col gap-4" data-id="element-706">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-707">
                      <div data-id="element-708">
                        <label className="font-inter text-[12px] text-white/40 mb-1.5 block tracking-widest" data-id="element-709">
                          YOUR NAME
                        </label>
                        <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Full name" className="w-full bg-white/5 border border-[#2A2622] rounded-xl px-4 py-3.5 text-[16px] text-white/80 font-inter focus:outline-none focus:border-[#C9A84C]/50 transition-colors placeholder:text-white/20" data-id="element-710" />
                      </div>
                      <div data-id="element-711">
                        <label className="font-inter text-[12px] text-white/40 mb-1.5 block tracking-widest" data-id="element-712">
                          EMAIL
                        </label>
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" className="w-full bg-white/5 border border-[#2A2622] rounded-xl px-4 py-3.5 text-[16px] text-white/80 font-inter focus:outline-none focus:border-[#C9A84C]/50 transition-colors placeholder:text-white/20" data-id="element-713" />
                      </div>
                    </div>

                    <div data-id="element-714">
                      <label className="font-inter text-[12px] text-white/40 mb-1.5 block tracking-widest" data-id="element-715">
                        SUBJECT
                      </label>
                      <div className="flex flex-wrap gap-2 mb-3" data-id="element-716">
                        {['General Inquiry', 'Reservations', 'Bottle Service', 'Events', 'Press & Media'].map(s => <button key={s} onClick={() => setSubject(subject === s ? '' : s)} className="px-3.5 py-2 rounded-xl font-inter text-[13px] transition-all duration-200" style={{
                      background: subject === s ? 'rgba(201,168,76,0.15)' : 'rgba(255,255,255,0.04)',
                      color: subject === s ? '#C9A84C' : 'rgba(255,255,255,0.45)',
                      border: subject === s ? '1px solid rgba(201,168,76,0.4)' : '1px solid #2A2622'
                    }} data-id="element-717">
                            {s}
                          </button>)}
                      </div>
                    </div>

                    <div data-id="element-718">
                      <label className="font-inter text-[12px] text-white/40 mb-1.5 block tracking-widest" data-id="element-719">
                        MESSAGE
                      </label>
                      <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="Tell us how we can help..." rows={6} className="w-full bg-white/5 border border-[#2A2622] rounded-xl px-4 py-3.5 text-[16px] text-white/80 font-inter focus:outline-none focus:border-[#C9A84C]/50 transition-colors placeholder:text-white/20 resize-none" data-id="element-720" />
                    </div>
                  </div>

                  <button onClick={handleSubmit} disabled={!name || !email || !message || isProcessing} className="w-full mt-6 font-montserrat font-black text-[13px] tracking-widest py-4 rounded-xl transition-all duration-300 flex items-center justify-center gap-2" style={{
                background: name && email && message ? '#C9A84C' : 'rgba(201,168,76,0.2)',
                color: name && email && message ? '#050505' : 'rgba(201,168,76,0.4)',
                cursor: name && email && message ? 'pointer' : 'not-allowed',
                opacity: isProcessing ? 0.8 : 1
              }} data-id="element-721">
                    {isProcessing ? <>
                        <motion.div animate={{
                    rotate: 360
                  }} transition={{
                    duration: 1,
                    repeat: Infinity,
                    ease: 'linear'
                  }} className="w-4 h-4 border-2 border-[#050505]/30 border-t-[#050505] rounded-full" data-id="element-722" />
                        SENDING...
                      </> : 'SEND MESSAGE'}
                  </button>
                </> : <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="h-full flex flex-col items-center justify-center text-center py-16 gap-5" data-id="element-723">
                  <motion.div initial={{
                scale: 0
              }} animate={{
                scale: 1
              }} transition={{
                type: 'spring',
                stiffness: 300,
                damping: 20,
                delay: 0.1
              }} className="w-20 h-20 rounded-full flex items-center justify-center" style={{
                background: '#C9A84C',
                boxShadow: '0 0 50px rgba(201,168,76,0.4)'
              }} data-id="element-724">
                    <CheckIcon size={36} className="text-[#050505]" data-id="element-725" />
                  </motion.div>
                  <h3 className="font-montserrat font-black text-2xl tracking-widest text-white" data-id="element-726">
                    MESSAGE SENT!
                  </h3>
                  <p className="font-inter text-[16px] text-white/50 max-w-sm leading-relaxed" data-id="element-727">
                    Thanks for reaching out. Our team will get back to you
                    within 24 hours.
                  </p>
                  <button onClick={() => setSubmitted(false)} className="mt-2 font-montserrat font-black text-[13px] tracking-widest border border-[#C9A84C]/40 text-[#C9A84C] px-8 py-3.5 rounded-xl hover:bg-[#C9A84C]/10 transition-all duration-300" data-id="element-728">
                    SEND ANOTHER
                  </button>
                </motion.div>}
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}